import { createAsyncThunk } from '@reduxjs/toolkit';
import transactionsModel from 'store/models/transactions';
import {
  ITransactionData,
  ITransactionMeta,
} from '../types/transactionsSchema';
import { CancelToken, isCancel } from 'axios';
import CONFIG from 'shared/constants/config';

//GET
export const fetchRespondentTransactions = createAsyncThunk(
  'transactions/fetchRespondentTransactions',
  async (
    data: { page: string; limit: number; cancelToken?: CancelToken },
    { rejectWithValue },
  ) => {
    try {
      const response: {
        data: { data: ITransactionData[]; meta: ITransactionMeta };
      } = await transactionsModel.getRespondentTransactions(data);

      return response;
    } catch (e) {
      if (!isCancel(e)) {
        return rejectWithValue(e);
      }

      // Любая другая ошибка — обрабатываем как обычно
    }
  },
);

//PUT
export const withdrawRespondentTransactions = createAsyncThunk(
  'transactions/withdrawRespondentTransactions',
  async (
    data: { bank_id: number; page: string },
    { rejectWithValue, dispatch },
  ) => {
    try {
      const { page, ...rest } = data;
      const response: {
        data: { data: ITransactionData[]; meta: ITransactionMeta };
      } = await transactionsModel.postRespondentTransactionsWithdraw(rest);
      if (String(page) === '1') {
        dispatch(
          fetchRespondentTransactions({ page, limit: CONFIG.PAGINATION_LIMIT }),
        );
      }
      return response;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
